export default "__VITE_ASSET__CW8d0yGb__"